import { fetchEventSource } from '@microsoft/fetch-event-source'
import { cloneDeep } from 'lodash'

import { SessionStatuTypes } from '@/constants'
import { SseResponseEventEnum } from '@/constants/agent'
import { chatSideBarAction, globalActions, globalState } from '@/store'
import { assistantAction, assistantState } from '@/store/assistant'
import { formatterHistory, getOriginPath } from '@/utils/common'
import { citationRegex, toCitationDirective } from '@/utils/formate'
import { message } from 'antd'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
const testSseUrl = getOriginPath() + '/ai-agent/api/core/chat/chatTest'
const chatSseUrl = getOriginPath() + '/ai-agent/api/v1/chat/completions'
export const useAgentChat = () => {
  const [abortController, setAbortController] = useState(new AbortController())
  const { userInfo } = globalState
  const { curSelectAssistant, isLoadingQuestion } = assistantState
  const [searchParams] = useSearchParams()
  const [isLoading, setIsLoading] = useState(false)
  // 是否手动停止会话
  const [isStop, setIsStop] = useState(false)
  const onUserSubmit = async (sendData: any) => {
    if (!assistantState.submittable) {
      message.error('请先完成智能体配置的必填项')
      return
    }
    if (!assistantState.curSelectAssistant?.app_id) {
      message.error('请先完成调试智能体创建')
      return
    }
    if (
      assistantState.sessionStatu !== SessionStatuTypes.ready ||
      isLoadingQuestion
    ) {
      message.open({
        key: 'assistant',
        type: 'warning',
        content: '请等待回复后再发送',
      })
      return
    }
    assistantAction.updateQuestionGuides([])

    assistantState.sessionMessages.push(
      {
        // chat_id: assistantState.curChatId,
        chat_id: '',
        obj: 'Human',
        value: sendData,
      },
      {
        loading: true,
        chat_id: '',
        obj: 'AI',
        value: '',
        avatar: curSelectAssistant.image,
      },
    )

    let sendMessage: any = {
      inputText: sendData,
      appId: assistantState.curSelectAssistant.app_id, // 测试插件，知识库
    }
    if (assistantState.curSelectAssistant?.debug) {
      const lastIndex = assistantState.sessionMessages.reduceRight(
        (acc: any, data: any, index: any) => {
          if (acc === -1 && data.newChat) {
            return index
          }
          return acc
        },
        -1,
      )
      let historyParams: any = []
      // 如果点击新的问答，历史聊天请求参数删掉最后一个newchat之前的内容
      if (lastIndex !== -1) {
        historyParams = formatterHistory(
          assistantState.sessionMessages.slice(0, -2 - (lastIndex + 1)),
        )
      } else {
        historyParams = formatterHistory(
          assistantState.sessionMessages.slice(0, -2),
        )
      }
      sendMessage.history = historyParams
    } else {
      sendMessage.chatId = assistantState.curChatId
    }
    let app_id = assistantState.curSelectAssistant.app_id
    setIsLoading(true)
    assistantState.autoBottom = true
    setIsStop(false)
    streamFetch(sendMessage, app_id)
  }
  const streamFetch = async (payload: any, app_id: any) => {
    if (!userInfo) {
      globalActions.logout()
    }
    assistantAction.updateSessionStatu(SessionStatuTypes.pending)
    let sseUrl = curSelectAssistant?.debug ? testSseUrl : chatSseUrl
    let msgQueen: any = []
    let curmsg: any = {}
    let toolObj: any = null
    let text = ''
    let queenText = ''
    await fetchEventSource(sseUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-store',
        authcode: userInfo.authCode || '',
        Token: userInfo.agent_token || '',
      },
      signal: abortController.signal,
      body: JSON.stringify(payload),
      openWhenHidden: true,
      async onopen(resp) {
        const contentype = resp.headers.get('content-type') || ''
        console.log('contentype =>', contentype)
        console.log('resp =>', resp)
        if (resp.status === 401) {
          globalActions.logout()
          stopSession()
          assistantAction.updateSessionStatu(SessionStatuTypes.ready)
        }
        if (resp.ok && !contentype.includes('text/event-stream')) {
          const responseData = await resp.json()
          console.log('responseData =>', responseData)
          stopSession()
          assistantAction.updateSessionStatu(SessionStatuTypes.ready)
        }
      },
      onmessage(message: any) {
        // 切换应用 停止当前会话
        if (app_id !== assistantState.curSelectAssistant?.app_id) {
          stopSession()
          return
        }
        const { event, data } = message
        const messages: any = cloneDeep(assistantState.sessionMessages)
        let lastMessage: any = messages[messages.length - 1] || {}
        let lastQueen = msgQueen?.length ? msgQueen[msgQueen.length - 1] : {}
        switch (event) {
          case SseResponseEventEnum.answer:
            if (data !== '[DONE]') {
              let jsonToParse = JSON.parse(data)?.choices?.[0]?.delta
              const content: string = jsonToParse?.content || ''
              queenText =
                lastQueen?.value &&
                lastQueen.event !== SseResponseEventEnum.error
                  ? lastQueen?.value + content
                  : content
              text = `${lastMessage.value}${content}`
              const toolResponse = msgQueen.find(
                (i: any) => i.event === SseResponseEventEnum.toolResponse,
              )
              if (citationRegex.test(queenText)) {
                const response = toolResponse
                  ? JSON.parse(toolResponse?.toolObj?.response || '{}')
                  : {}
                const citationText = toCitationDirective(
                  queenText,
                  response.result || [],
                )
                queenText = `${citationText}`
              }
              /** 后面估计要废弃 */
              curmsg = {
                event,
                value: queenText,
              }
              if (lastQueen.event === SseResponseEventEnum.flowNodeStatus) {
                msgQueen.pop() // 删除最后一个
              }
              if (lastQueen.event !== SseResponseEventEnum.answer) {
                msgQueen = [...msgQueen, curmsg] // 创建新的数组引用
              } else {
                msgQueen = [...msgQueen.slice(0, -1), curmsg] // 创建新的数组引用
              }
              lastMessage = {
                ...lastMessage,
                value: text,
                loading: false,
                msgQueen,
              }
              messages.splice(messages.length - 1, 1, lastMessage)
              assistantAction.updateSessionMessages(messages)
            }
            break
          case SseResponseEventEnum.flowNodeStatus:
            if (JSON.parse(data)?.name !== '文生图') break
            toolObj = JSON.parse(data)?.tool || {}
            curmsg = {
              event,
              toolObj,
            }
            if (lastQueen.event !== SseResponseEventEnum.flowNodeStatus) {
              msgQueen = [...msgQueen, curmsg] // 创建新的数组引用
            } else {
              msgQueen = [...msgQueen.slice(0, -1), curmsg] // 创建新的数组引用
            }
            lastMessage = {
              ...lastMessage,
              loading: false,
              msgQueen,
            }
            messages.splice(messages.length - 1, 1, lastMessage)
            assistantAction.updateSessionMessages(messages)
            break
          case SseResponseEventEnum.toolCall:
            toolObj = JSON.parse(data)?.tool || {}
            curmsg = {
              event,
              toolObj,
            }
            if (
              lastQueen.event !== SseResponseEventEnum.toolCall ||
              lastQueen.event !== SseResponseEventEnum.flowNodeStatus
            ) {
              msgQueen = [...msgQueen, curmsg] // 创建新的数组引用
            } else {
              msgQueen = [...msgQueen.slice(0, -1), curmsg] // 创建新的数组引用
            }
            lastMessage = {
              ...lastMessage,
              toolObj,
              loading: false,
              msgQueen,
            }
            messages.splice(messages.length - 1, 1, lastMessage)
            assistantAction.updateSessionMessages(messages)
            break
          case SseResponseEventEnum.toolParams:
            // eslint-disable-next-line no-lone-blocks
            {
              const params: any = JSON.parse(data)?.tool?.params || ''
              toolObj = { ...toolObj, params }
              curmsg = {
                event,
                toolObj,
              }
              msgQueen = [...msgQueen.slice(0, -1), curmsg] // 创建新的数组引用
              lastMessage = {
                ...lastMessage,
                toolObj,
                loading: false,
                msgQueen,
              }
              messages.splice(messages.length - 1, 1, lastMessage)
              assistantAction.updateSessionMessages(messages)
            }
            break
          case SseResponseEventEnum.toolResponse:
            // eslint-disable-next-line no-lone-blocks
            {
              const response: any = JSON.parse(data)?.tool?.response || ''
              toolObj = { ...toolObj, response }
              curmsg = {
                event,
                toolObj,
              }
              msgQueen = [...msgQueen.slice(0, -1), curmsg] // 创建新的数组引用
              lastMessage = {
                ...lastMessage,
                toolObj,
                loading: false,
                msgQueen,
              }
              messages.splice(messages.length - 1, 1, lastMessage)
              assistantAction.updateSessionMessages(messages)
            }
            break
          case SseResponseEventEnum.info:
            {
              let jsonToParse = JSON.parse(data)
              const referenceDocs: any = jsonToParse?.reference_docs || null
              curmsg = {
                event,
                referenceDocs,
              }
              msgQueen = [...msgQueen, curmsg]
              lastMessage = {
                ...lastMessage,
                loading: false,
                msgQueen,
              }
              console.log('lastMessage', lastMessage)
              messages.splice(messages.length - 1, 1, lastMessage)
              assistantAction.updateSessionMessages(messages)
            }
            break
          case SseResponseEventEnum.appStreamResponse:
            assistantAction.updateSessionStatu(SessionStatuTypes.ready)
            break
          case SseResponseEventEnum.error:
            setIsLoading(false)
            if (data.status === 401) {
              assistantAction.updateSessionStatu(SessionStatuTypes.ready)
            } else {
              curmsg = {
                event,
                value: JSON.parse(data)?.message || '抱歉，暂无法回答问题',
              }
              msgQueen = [curmsg] // 创建新的数组引用
              console.log(msgQueen)
              lastMessage = {
                ...lastMessage,
                value: JSON.parse(data)?.message || '抱歉，暂无法回答问题',
                loading: false,
                msgQueen,
              }
              messages.splice(messages.length - 1, 1, lastMessage)
              assistantAction.updateSessionMessages(messages)
            }
            stopSession()
            break
        }
      },
      onerror(err: any) {
        setIsLoading(false)
        assistantAction.updateSessionStatu(SessionStatuTypes.ready)
        console.log('eventSource error: ', `${err}`)
        throw err
      },
      onclose() {
        setIsLoading(false)
        console.log('eventSource close')
        assistantState.autoBottom = false
        assistantAction.updateSessionStatu(SessionStatuTypes.ready)
        if (!isStop) {
          if (curSelectAssistant.question_guide) {
            assistantState.isLoadingQuestion = true
            assistantAction.questionGuide({
              appId: assistantState.curSelectAssistant.app_id,
              chatId: assistantState.curChatId, // 会话的chatId
            })
          }
        }

        if (!assistantState.curSelectAssistant?.debug) {
          chatSideBarAction.getHistoryRecord()
        }
      },
    })
  }
  const stopSession = () => {
    setIsStop(true)
    console.log('stopSession-------')
    setIsLoading(false)
    abortController.abort()
    setAbortController(new AbortController())
    assistantAction.updateSessionStatu(SessionStatuTypes.ready)
    // if (curSelectAssistant.question_guide) {
    //   assistantState.isLoadingQuestion = true
    //   assistantAction.questionGuide({
    //     appId: assistantState.curSelectAssistant.app_id,
    //     chatId: assistantState.curChatId, // 会话的chatId
    //   })
    // }
  }
  return {
    onUserSubmit,
    stopSession,
    isLoading,
  }
}
